// Import Redux
import { combineReducers } from "redux"
// Import Reducers
import backgroundReducer from "./backgroundReducer"
import homeReducer from "./homeReducer"
import offeringsReducer from "./offeringsReducer"
import registerReducer from "./registerReducer"
import creatorOfferingReducer from "./creatorOfferingReducer"
import modalReducer from "./modalReducer"
import termsReducer from "./termsReducer"
import generalReducer from "./generalReducer"




// General State
export default combineReducers({
  background: backgroundReducer,
  general: generalReducer,
  home: homeReducer,
  register: registerReducer,
  offerings: offeringsReducer,
  creatorOffering: creatorOfferingReducer,
  modal: modalReducer,
  terms: termsReducer
})
